<template>
	<div class="thermostat-selection">
		<p class="h3 mb-2 pt-2 pb-4">Choisissez le type de thermostat que vous désirez</p>

	    <div class="form-check check-tile mb-3" @click="setDataRad('thermostat','Intégré')">
	    	<input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios1" value="option1">
	    	<router-link tag="label" class="form-check-label" for="exampleRadios1" :to="{name:routerTo}">
	    		<div class="d-block d-md-flex align-items-center">
		          <img class="rounded" src="../assets/img/thermostat-integre.jpg">
		          <div class="ml-md-4">
		            <p class="mb-0 lead">Intégré</p>
		            <span class="text-secondary">Simple d’utilisation et vous permet de réguler la température souhaitée au demi-degré près.</span>
		          </div>
		        </div>
		        <i class="ml-4 fal fa-arrow-right fa-2x text-primary"></i>
	       	</router-link>
	    </div>

	    <div class="form-check check-tile" @click="setDataRad('thermostat','Sans fil')">
	       <input class="form-check-input d-none" type="radio" name="step-1" id="exampleRadios2" value="option2">
	        <router-link tag="label" class="form-check-label" for="exampleRadios2" :to="{name:routerTo}">
	        	<div class="d-block d-md-flex align-items-center">
		          <img class="rounded" src="../assets/img/thermostat-sans-fil.jpg">
		          <div class="ml-md-4">
		            <p class="mb-0 lead">Sans fil</p>
		            <span class="text-secondary">Programmez et régulez plusieurs radiateurs d’une même pièce avec un seul thermostat.</span>
		          </div>
		        </div>
		        <i class="ml-4 fal fa-arrow-right fa-2x text-primary"></i>
	        </router-link>
	    </div>

	    <div class="d-flex align-items-center mt-4">
	    	<img src="../assets/img/icons/icon-config-evolutive.svg" class="mr-3">
	    	<p class="mb-0"><strong>Configuration évolutive : </strong><span class="text-secondary">Selon vos besoins et vos envies, changez de solution pour passer <br>d’un thermostat intégré à un thermostat sans fil, ou l’inverse, sans changer de radiateur !</span></p>
	    </div>
	    
	</div>
</template>

<script>
export default {
  name: "ThermostatSelection",
  computed:{
    routerTo(){
      if (this.state.radiator.orientation=='vertical'&&(this.state.room_type=='salle-de-bain'||this.state.room_type=='cuisine')){
        return 'TowelSelection'
      }
      else return 'PilotingSelection'
    }
  }
}
</script>

<style scoped>

</style>